import { render, staticRenderFns } from "./BulmaCheckbox.vue?vue&type=template&id=d1a2121e"
import script from "./BulmaCheckbox.vue?vue&type=script&lang=js"
export * from "./BulmaCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1a2121e')) {
      api.createRecord('d1a2121e', component.options)
    } else {
      api.reload('d1a2121e', component.options)
    }
    module.hot.accept("./BulmaCheckbox.vue?vue&type=template&id=d1a2121e", function () {
      api.rerender('d1a2121e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BulmaCheckbox/BulmaCheckbox.vue"
export default component.exports